import type { ButtonProps } from '@mui/material/Button';
import type { Theme, SxProps } from '@mui/material/styles';

import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import Button from '@mui/material/Button';

import { useRouter } from 'src/routes/hooks';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  sx?: SxProps<Theme>;
  onClose?: () => void;
};

export function SignOutButton({ onClose, ...other }: Props) {
  const router = useRouter();

  const { checkUserSession } = useAuthContext();
  const { logout: signOutAuth0 } = useAuth0();

  // const handleLogout = useCallback(async () => {
  //   try {
  //     await signOut();
  //     await checkUserSession?.();

  //     onClose?.();
  //     router.refresh();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }, [checkUserSession, onClose, router]);

  const handleLogoutAuth0 = useCallback(async () => {
    try {
      await signOutAuth0();

      onClose?.();
      router.refresh();
    } catch (error) {
      console.error(error);
      // toast.error('Unable to logout!');
    }
  }, [onClose, router, signOutAuth0]);

  return (
    <Button fullWidth variant="soft" size="large" color="error" onClick={handleLogoutAuth0} {...other}>
      Logout
    </Button>
  );
}
